<template>
    <v-container>
      <template v-if="maintain">
        <div class="d-flex justify-center align-center">
          <span style="font-size: 50px;color: #ff6d81">ปิดปรับปรุงระบบชั่วคราว</span>
        </div>
      </template>
      <template v-else>
        <template v-if="CheckAdmin">
            <v-card
                    class="mx-auto"
            >
                <v-card-title>
                    <v-icon
                            large
                            left
                    >
                        mdi-file-edit
                    </v-icon>
                    <span>รายงาน</span>
                </v-card-title>

                <v-card-text class="headline font-weight-bold">
                </v-card-text>

                <v-card-actions class="justify-space-around">
                    <v-row
                            class="justify-space-around"
                    >
                        <v-col align="center" col="12" md="8">
                            <v-btn
                                    text
                                    v-for="menu in Menu"
                                    :key="menu.id"
                                    @click="goToPage(menu.page)">
                                <span>{{menu.value}}</span>
                            </v-btn>
                            <hr/>
                        </v-col>
                    </v-row>
                </v-card-actions>

                <router-view></router-view>

            </v-card>
        </template>
        <template v-else></template>
      </template>
    </v-container>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import ConstData from "@/const/Const";

    export default {
        name: "Report",
        data() {
            return {
              maintain: false,
                CheckAdmin: false,
                Menu: [
                    {
                        id: '1',
                        value: 'จำนวนที่ถือครอง 30 %',
                        page: '/Report/Report30per'
                    },
                    {
                        id: '2',
                        value: 'บุคลากรตามตำแหน่งวิชาการ',
                        page: '/Report/AcademicPosition'
                    }
                ]
            }
        },
        computed: {
            ...mapGetters({
                MeData: 'Staff/getMeData',
              AllDepPermission: 'Permission/getAllDepUserPermission',
              DepPermission: 'Permission/getDepUserPermission',
              PermissionAdmin: 'Permission/getPermission',
              Permission: 'Permission/getPermissionUser',
              Permission_Ms: 'Permission/getPermissionMs',
              Permission_Dep_User: 'Permission/getPermissionDepUser',
              Permission_Dep: 'Permission/getPermissionDep',
              Approve_Ms: 'Permission/getApproveMs',
              Approve: 'Permission/getApprove',
              MenuPermiss: 'Permission/getMenuPermiss',
            })
        },
        methods: {
            ...mapActions({
                initMeData: 'Staff/initMeData',
              initPermissionDepUserAllData: 'Permission/initPermissionDepUserAllData',
              initPermissionDepUserData: 'Permission/initPermissionDepUserData',
              initPermissionUserData: 'Permission/initPermissionUserData',
              initPermissionMsData: 'Permission/initPermissionMsData',
              getPermissionUserData: 'Permission/getPermissionUserData',
              getPermissionDep: 'Permission/getPermissionDepData',
              initPermissionDepData: 'Permission/initPermissionDepData',
              getPermissionDepUserData: 'Permission/getPermissionDepUserData',
              initApproveMsData: 'Permission/initApproveMsData',
              initApproveData: 'Permission/initApproveData',
              getPermissionData: 'Permission/getPermissionData',
              initPermissionData: 'Permission/initPermissionData',
              getMenuPermissData: 'Permission/getMenuPermissData',
              changeColor: 'Page/changeColor',
              changeHeaderName: 'Page/changeHeaderName',
              changeTypeProject: 'Project/changeTypeProject',
            }),
            onResize() {
                this.isMobile = window.innerWidth < 600
            },
            goToPage: function (page) {
                this.$router.push(page)
            }
        },
        mounted() {
          this.changeColor({
            color: ConstData.defaultColorApp
          })
          this.changeHeaderName({
            headerName: ConstData.defaultHeaderApp
          })
          this.changeTypeProject({
            type: null
          })
            this.initMeData().then(res => {
                if (res) {
                  this.getMenuPermissData().then(res => {
                    if (res) {
                      if (this.MenuPermiss.length > 0 && this.MenuPermiss.filter(item => item.page_id == '17' && item.page_status == '1').length > 0) {
                        this.maintain = false
                        this.getPermissionData({
                          perid: this.MeData[0].perid
                        }).then(res => {
                          if (res) {
                            this.PermissionAdmin.map((Per_i, idx) => {
                              if(Per_i.permission_id == '6000') {
                                this.CheckAdmin = true
                              } else {
                                if(!this.CheckAdmin && idx == this.PermissionAdmin.length - 1) {
                                  this.$router.push('/')
                                }
                              }
                            })
                          } else {
                            // this.$router.push('/')
                            this.getPermissionUserData({
                              perid: this.MeData[0].perid
                            }).then(res => {
                              if (res) {
                                this.Permission.map((Per_i, idx) => {
                                  if(Per_i.permission_id == '6000') {
                                    this.CheckAdmin = true
                                  } else {
                                    if(!this.CheckAdmin && idx == this.Permission.length - 1) {
                                      this.$router.push('/')
                                    }
                                  }
                                })
                              } else {
                                this.$router.push('/')
                              }
                            })
                          }
                        })
                      } else {
                        this.maintain = true
                      }
                    }
                  }).then(err => {
                    if (err) {
                      this.maintain = true
                    }
                  })
                }
            }).catch(reason => {
                console.log('Reject = ' + reason)
            })
        }
    }
</script>

<style scoped>

</style>
